import { ColorVariant, ComponentAlignment, List } from '@makyoapp/makyo-tw-ui'
import { ListCardProps } from '@makyoapp/makyo-tw-ui/dist/components/list/list-card'

import { LayoutDemo } from './LayoutDemo'

export const ListDemo = () => {
  const generateRandomItem = (index: number): Omit<ListCardProps, 'trailingElements' | 'onItemClick'> => {
    const titles = [
      'Marketing Campaign',
      'Website Redesign',
      'Mobile App Development',
      'Brand Strategy',
      'Content Creation',
      'Social Media Management',
      'Very Long Title For Social Media Management Alternative Animal Playground',
      `Chambraylly.`,
      `banh t crucifix. Post-ironic `,
      `3 wolf moon typewriter retrot trade actually umami banh mi Yuccie.`,
      `Yuccie green scenester meditation Thundercats kogi. `,
    ]
    const supportingTexts = ['42 tasks', '18 items', '7 milestones', '3 sprints', '12 issues', '5 goals']

    // Sample badge texts
    const badgeTexts = [
      'New Product',
      'Hot',
      '10+',
      '5',
      'Urgent',
      'Due',
      'Priority',
      'Featured',
      'Popular',
      'Limited',
      '',
    ]

    // Sample image URLs for random selection
    const imageUrls = [
      'https://a3q5.c18.e2-3.dev/makyo-dev/assets/images/animes/M5.jpg',
      'https://a3q5.c18.e2-3.dev/makyo-dev/assets/images/animes/M1.jpg',
      'https://a3q5.c18.e2-3.dev/makyo-dev/assets/images/animes/M2.jpg',
      'https://a3q5.c18.e2-3.dev/makyo-dev/assets/images/animes/M3.jpg',
      'https://a3q5.c18.e2-3.dev/makyo-dev/assets/images/animes/M4.jpg',
    ]

    return {
      id: `item-${index}`,
      title: titles[index % titles.length],
      badgeText: badgeTexts[index % badgeTexts.length],
      supportingText: supportingTexts[index % supportingTexts.length],
      imageUrl: imageUrls[index % imageUrls.length],
      iconFill: false,
      iconSize: 24,
      backgroundColorPage: 'primary-90',
    }
  }

  const args = {
    // Layout
    columns: 1,
    totalCards: 2,
    widthUnit: '%',
    percentWidth: 100,
    pixelWidth: 800,
    forceSameHeight: true,
    orientation: 'vertical',

    // Spacing for List
    mainWrapperPaddingTop: 0,
    mainWrapperPaddingRight: 0,
    mainWrapperPaddingBottom: 0,
    mainWrapperPaddingLeft: 0,
    mainWrapperMarginTop: 0,
    mainWrapperMarginRight: 0,
    mainWrapperMarginBottom: 0,
    mainWrapperMarginLeft: 0,

    // Spacing for ListCard
    itemPaddingTop: 16,
    itemPaddingRight: 24,
    itemPaddingBottom: 16,
    itemPaddingLeft: 24,
    itemMarginTop: 0,
    itemMarginRight: 16,
    itemMarginBottom: 16,
    itemMarginLeft: 0,

    // Typography
    titleTypography: {
      typography: 'Body Medium',
    },
    supportingTextTypography: {
      typography: 'Body Medium',
    },

    // Title
    componentTitle: '',
    mainTitleTypography: 'title-medium',
    titleAlign: 'left',
    // imageAspectRatio: 'auto',

    backgroundColor: 'primary-80' as ColorVariant,
  }

  const items = Array.from({ length: args.totalCards }).map((_, index) => {
    const itemId = `item-${index}`
    const itemData = {
      ...generateRandomItem(index),
      id: itemId,
      useImage: true,
      imageAspectRatio: 'auto' as const,
      trailingElements: [],
      ...args,
    }
    return itemData
  })

  return (
    <LayoutDemo title='List' bgColor='var(--color-primary-90)'>
      <List
        showBorder={false}
        items={items}
        onItemClick={() => {}}
        widthAmount={args.percentWidth}
        widthUnit={args.widthUnit === '%' ? 'percentage' : 'pixel'}
        align={'center' as ComponentAlignment}
        itemSpacing={{
          padding: {
            top: args.itemPaddingTop,
            right: args.itemPaddingRight,
            bottom: args.itemPaddingBottom,
            left: args.itemPaddingLeft,
          },
        }}
        forceSameHeight={args.forceSameHeight}
        columns={args.columns}
        componentTitle={args.componentTitle}
        mainTitleTypography={args.mainTitleTypography}
        titleAlign={args.titleAlign as 'left' | 'center' | 'right'}
        orientation={args.orientation as 'vertical' | 'horizontal'}
        stacked={false}
        onStackedChange={() => {}}
        onLayoutChange={() => {}}
      />
    </LayoutDemo>
  )
}
